<template>
  <el-dialog :visible.sync="visible" title="批量联系商家" width="426px" :before-close="handleClose">
    <p class="yx-color-text-primary">
      共选中<span class="yx-color-primary ml-4 mr-4 font-bold">{{ total }}</span
      >个订单，其中<span class="yx-color-primary ml-4 mr-4 font-bold">{{
        fliterTotal
      }}</span
      >订单未联系商家。
    </p>
    <div class="flex mt-10 flex-align-center">
      <div class="flex">
        <explain :content="content" class="ml-6 yx-color-text-regular"></explain>
        <p class="ml-4">是否已联系商家</p>
      </div>
      <div class="flex flex-align-center mt-6 ml-10">
        <el-radio v-model="contact_status" label="1">是</el-radio>
        <el-radio v-model="contact_status" label="0">否</el-radio>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit" :disabled="isDisabled"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { sampleOrderMerchant } from "@/api/sampleOrder";
import Explain from '@/components/common/explain';
export default {
  components: {
    Explain
  },
  computed: {
    content() {
      return "若设为“已联系商家”，针对“未发货”状态的样品订单会展示【已联系商家】的标识，若设为“未联系商家”，则展示【未联系商家标识】";
    },
  },
  data() {
    return {
      visible: false,
      total: 0,
      fliterTotal: 0,
      sample_sn: "",
      contact_status: "",
      isDisabled: true,
    };
  },
  watch: {
    contact_status: {
      handler(to) {
        if (to) {
          this.isDisabled = false;
        } else {
          this.isDisabled = true;
        }
      },
    },
  },
  methods: {
    show(total, fliterTotal, sample_sn) {
      this.total = total;
      this.fliterTotal = fliterTotal;
      this.sample_sn = sample_sn;
      this.visible = true;
    },
    async submit() {
      const { sample_sn, contact_status } = this;
      const { code } = await sampleOrderMerchant({
        contact_status,
        sample_sn,
      });
      if (code !== 0) return;
      this.$message.success("修改成功");
      this.$emit("refreshList");
      this.handleClose()
    },
    handleClose() {
      this.visible = false
      this.contact_status = ''
      this.sample_sn = ''
      this.fliterTotal = 0
      this.isDisabled = true
      this.total = 0
    },
  },
};
</script>